import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=fe447b60&scoped=true&"
import script from "./appMain.vue?vue&type=script&lang=js&"
export * from "./appMain.vue?vue&type=script&lang=js&"
import style0 from "./appMain.vue?vue&type=style&index=0&id=fe447b60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe447b60",
  null
  
)

export default component.exports